
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/nodes",
      function () {
        return require("private-next-pages/dashboard/nodes/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/nodes"])
      });
    }
  